import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const ChevronLeftIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path d="M14.2 6.79999C14.5 6.79999 14.7 6.89999 14.9 7.09999C15.3 7.49999 15.3 8.09999 14.9 8.49999L11.4 12L14.9 15.5C15.3 15.9 15.3 16.5 14.9 16.9C14.5 17.3 13.9 17.3 13.5 16.9L9.30001 12.7C8.90001 12.3 8.90001 11.7 9.30001 11.3L13.5 7.09999C13.7 6.89999 13.9 6.79999 14.2 6.79999Z" />
    </Icon>
  );
};
